import { render, staticRenderFns } from "./BnToTheTopBtn.vue?vue&type=template&id=7ce7bb08&scoped=true&"
import script from "./BnToTheTopBtn.vue?vue&type=script&lang=js&"
export * from "./BnToTheTopBtn.vue?vue&type=script&lang=js&"
import style0 from "./BnToTheTopBtn.vue?vue&type=style&index=0&id=7ce7bb08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ce7bb08",
  null
  
)

export default component.exports